export enum SELECTOR {
  MAIN_WRAPPER = 'main-wrapper',
  MAIN = 'main',
  PAGE_NAV_WRAPPER = 'page-nav-wrapper',
  MAP_NAVIGATION = 'map-navigation',
  COMMENT_LIST_TOP = 'comment-list-top',
  COMMENT_PREFIX = 'comment-id-',
  GLOBAL_NAVIGATION = 'global-navigation',
  SESSION_PORTAL_CONTENT = 'session-portal-content',
  JEJU_BENEFIT_MAP_NAVIGATION = 'jeju-benefit-map-navigation',
}
